// initial state
const state = {
   top:-1,
   marginTop:0
};

const VIEW_WINDOW = 140;

// getters
const getters = {
};

// actions
const actions = {
	SCROLL_WINDOW_TOP: function(context){
      context.commit('SCROLL_TOP_SET',0);
   },
	SCROLL_CONTENT_TOP: function(context){
      context.commit('SCROLL_TOP_MARGIN_SET');
   },
   SCROLL_TOP_RESET: function(context){
      context.commit('SCROLL_TOP_SET',-1);
   },
   SCROLL_MARGIN_TOP_SET: function(context,{device,viewWindow}){
      let viewMargin = viewWindow || VIEW_WINDOW;
      if (device === 'mobile') return context.commit('MARGIN_TOP_SET',window.innerHeight - VIEW_WINDOW);
      return context.commit('MARGIN_TOP_SET',0);
   }
};

// mutations
const mutations = {
   SCROLL_TOP_SET: (state, top)=>{
   	state.top = top;
   },
   SCROLL_TOP_MARGIN_SET: (state)=>{
   	state.top = state.marginTop;
   },
   MARGIN_TOP_SET: (state,marginTop)=>{
      state.marginTop = marginTop;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/scroll.js